import { render } from "./ModalView.vue?vue&type=template&id=9779f7ea"
import script from "./ModalScript.vue?vue&type=script&lang=js&external"
export * from "./ModalScript.vue?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__